import harry from '../../../e2e/fixtures/media/student-harry.jpg';
import hermione from '../../../e2e/fixtures/media/student-hermione.jpg';
import ron from '../../../e2e/fixtures/media/student-ron.jpg';
import snape from '../../../e2e/fixtures/media/lecturer-snape.jpg';

/**
 * Same portraits the oral-exam e2e / Playwright gates inject as fake cameras.
 * Required so Visual Lab and the live walks share one set of faces.
 */
const SLIDE_SVG = encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="1600" height="900" viewBox="0 0 1600 900">'
  + '<rect width="1600" height="900" fill="#1b1f27"/>'
  + '<text x="96" y="180" fill="#f4f7fb" font-size="72" font-family="Georgia, serif">Canonical lock</text>'
  + '<text x="96" y="280" fill="#9aa7b8" font-size="36" font-family="sans-serif">1. One source of truth</text>'
  + '<text x="96" y="350" fill="#9aa7b8" font-size="36" font-family="sans-serif">2. No heal on read</text>'
  + '<text x="96" y="420" fill="#9aa7b8" font-size="36" font-family="sans-serif">3. Reset clears the exam session</text>'
  + '</svg>',
);

export const PATROL_LAB_STANDINS = {
  harry,
  hermione,
  ron,
  snape,
  slide: { uri: `data:image/svg+xml;charset=utf-8,${SLIDE_SVG}`, width: 1600, height: 900 },
} as const;
